"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var _default = exports["default"] = function _default(data, projectId) {
  var variableTypes = {
    quantitative: 'Quantitative',
    qualitative: 'Qualitative',
    summary_usage: 'Summary Usage'
  };
  var variables = {};
  var _iterator = _createForOfIteratorHelper(data.metrics.variableList),
    _step;
  try {
    var _loop = function _loop() {
      var variable = _step.value;
      var type = variable.type;
      var _iterator2 = _createForOfIteratorHelper(variable.key.assignment.deploymentList),
        _step2;
      try {
        var _loop2 = function _loop2() {
          var deploymentId = _step2.value.deploymentId;
          variables[deploymentId] = variables[deploymentId] || [];
          var typeGroup = variables[deploymentId].find(function (item) {
            return item.id === "".concat(type).concat(deploymentId);
          });
          if (!typeGroup) {
            typeGroup = {
              id: "".concat(type).concat(deploymentId),
              label: "".concat(variableTypes[type] || type, " Metrics"),
              children: []
            };
            variables[deploymentId].push(typeGroup);
          }
          typeGroup.children.push({
            id: "variables".concat(deploymentId, ".variables.").concat(variable.reportHeader),
            query: "variables".concat(deploymentId, ":assignmentProgress(deploymentId:").concat(deploymentId, ").variables.").concat(variable.reportHeader),
            label: variable.reportHeader,
            type: 'string'
          });
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var map = {};
  data.flows.assignmentList.forEach(function (assignment) {
    var deployments = assignment.deploymentList.map(function (deployment) {
      return {
        id: "deployment".concat(deployment.deploymentId),
        label: deployment.label,
        children: [{
          id: "progress".concat(deployment.deploymentId, ".status"),
          query: "progress".concat(deployment.deploymentId, ":assignmentProgress(deploymentId:").concat(deployment.deploymentId, ").status"),
          label: 'Status',
          type: 'string'
        }, {
          id: "progress".concat(deployment.deploymentId, ".startedDate"),
          query: "progress".concat(deployment.deploymentId, ":assignmentProgress(deploymentId:").concat(deployment.deploymentId, ").startedDate"),
          label: 'Started Date',
          type: 'string'
        }, {
          id: "progress".concat(deployment.deploymentId, ".completedDate"),
          query: "progress".concat(deployment.deploymentId, ":assignmentProgress(deploymentId:").concat(deployment.deploymentId, ").completedDate"),
          label: 'Completed Date',
          type: 'string'
        }].concat(_toConsumableArray(variables[deployment.deploymentId] || []))
      };
    });
    if (deployments.length === 0) {
      return;
    }
    map[assignment.groupId] = map[assignment.groupId] || [];
    map[assignment.groupId].push({
      id: "assignment".concat(assignment.assignmentId),
      label: assignment.label,
      children: deployments
    });
  });
  var projects = data.groups.questprojectList.map(function (project) {
    return {
      id: "project".concat(project.group.groupId),
      projectId: project.group.groupId,
      label: project.group.label,
      children: map[project.group.groupId] || []
    };
  }).filter(function (project) {
    return project.children.length > 0;
  });
  if (projectId) {
    var projectInfo = projects.find(function (project) {
      return project.projectId === projectId;
    });
    return projectInfo ? projectInfo.children : [];
  }
  return projects;
};